// extracted by mini-css-extract-plugin
export default {"iframe":"I7i1mL","fillAllSpace":"qWNuNp","absolute":"pdSSQG"};